import { apiClient } from '@/lib/api-client';

/**
 * Ops simulation T16 — staff POS PIN and on-device manager approval.
 * A protected action names one of these when it asks and when it spends the token.
 */
export type ManagerApprovalAction =
  | 'RETURN_OVER_THRESHOLD'
  | 'CREDIT_OVER_LIMIT'
  | 'TAX_SWITCH'
  | 'CASH_DIFFERENCE';

export interface Approver {
  id: string;
  name: string;
  role: 'OWNER' | 'MANAGER';
}

export interface ManagerApprovalGrant {
  approval_id: string;
  /** Single use, about 5 minutes, only for the signed-in user. */
  approval_token: string;
  expires_at: string;
  approver: Approver;
}

export interface VerifyManagerPinDto {
  approver_id: string;
  pin: string;
  action: ManagerApprovalAction;
  subject_id?: string;
  amount?: number;
  location_id?: string;
}

export const managerApprovalService = {
  getOwnPinStatus() {
    return apiClient<{ has_pin: boolean }>('/manager-approval/pin');
  },

  /** Changing an existing PIN needs `current_pin`. */
  setOwnPin(pin: string, currentPin?: string) {
    return apiClient<{ has_pin: true }>('/manager-approval/pin', {
      method: 'PUT',
      body: { pin, ...(currentPin ? { current_pin: currentPin } : {}) },
    });
  },

  listApprovers(locationId?: string) {
    const qs = locationId ? `?location_id=${encodeURIComponent(locationId)}` : '';
    return apiClient<Approver[]>(`/manager-approval/approvers${qs}`);
  },

  verify(dto: VerifyManagerPinDto) {
    return apiClient<ManagerApprovalGrant>('/manager-approval/verify', {
      method: 'POST',
      body: dto,
    });
  },
};
